<span [ngClass]="{'text-success': isGood, 'text-danger': isBad}">{{sign && display > 0 ? '+' : ''}}{{display | number : '1.0-' + decimal : 'en-US'}}</span>
